<script setup lang="ts">
import { computed } from 'vue'
import { paletteForKey, type PaletteHue } from '@/design-system/components'

/** Hue-soft monogram avatar (photo when available). Hue defaults to hash(key). */
const props = withDefaults(
  defineProps<{
    first?: string
    last?: string
    keyId?: string
    hue?: PaletteHue
    size?: number
    photoUrl?: string | null
  }>(),
  { size: 36 },
)

const hue = computed(() => props.hue ?? paletteForKey(props.keyId ?? `${props.first} ${props.last}`))
const initials = computed(
  () => `${props.first?.[0] ?? ''}${props.last?.[0] ?? ''}`.toUpperCase() || '?',
)
</script>

<template>
  <span
    class="mono"
    :style="{
      width: size + 'px',
      height: size + 'px',
      background: hue.soft,
      color: hue.ink,
      fontSize: size > 34 ? '12.5px' : size > 28 ? '11px' : '9.5px',
    }"
  >
    <img v-if="photoUrl" :src="photoUrl" alt="" class="mono__img" />
    <template v-else>{{ initials }}</template>
  </span>
</template>

<style scoped>
.mono {
  flex-shrink: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-sans);
  font-weight: 600;
  letter-spacing: 0.2px;
  overflow: hidden;
}
.mono__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
